module.exports = __webpack_public_path__ + "static/media/export.f4a90319.svg";